import { GeoJSON } from "react-leaflet";

import { useFlandersFeature } from "../../hooks/mapHooks";
import { Layer, MapPositionBounds } from "../../types";

interface Props {
  layer: Layer;
  mapPosition: MapPositionBounds;
}

export function SelectedLayerFlandersGeometry(props: Props) {
  const { layer, mapPosition } = props;
  const { data: feature } = useFlandersFeature(layer, mapPosition);

  return (
    <>
      {feature && (
        <GeoJSON
          data={feature}
          style={undefined}
          //@ts-ignore: function cannot return NULL.. for legacy purposes i'll leave it.
          //TODO: figure out how to fix this, Leaflet update? ( But that might break a wholatta other stuff )
          pointToLayer={() => {
            // render no point base GeoJSON, because multiple points would overlap
            // points are rendered by this.props.markers data
            return null;
          }}
        />
      )}
    </>
  );
}
